import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { WhiteBox } from 'components/flink-play';
import { StarIcon } from 'components/flink-play/FlinkPlayIcons/FlinkPlayIcons';
import classes from './MenuGroupView.module.scss';

const IKTYW = 'I Know These Words';

const MenuGroupView = ({
  title,
  items,
  learners,
  highlight,
  withoutStars,
  activityClickHandler,
  groupClickHandler,
  solutionLocale,
}) => {
  console.debug('[MGV] raw items:', items);
  console.debug('[MGV] first item raw:', Array.isArray(items) ? items[0] : null);
  console.debug(
    '[MGV] first item keys:',
    Array.isArray(items) && items[0] ? Object.keys(items[0]) : []
  );
  console.debug(
    '[MGV] items deep snapshot:',
    Array.isArray(items) ? JSON.parse(JSON.stringify(items)) : items
  );

  window.__mgvItems = items;
  console.debug('[MGV] window.__mgvItems assigned');

  const inOrder = Array.isArray(items)
    ? items.map((i) => i?.activityName || i?.formattedName || i?._id)
    : [];

  console.debug('[MGV] in:', inOrder);
  console.debug('[MGV] solutionLocale:', solutionLocale);

  const base = Array.isArray(items) ? items.filter(Boolean) : [];
  let listForRender = base.slice();

  if (listForRender.length && !listForRender[0].isGroup) {
    const idx = listForRender.findIndex((it) => {
      const fn = it?.formattedName || '';
      const an = it?.activityName || '';
      return fn === IKTYW || an === IKTYW || an.endsWith(`~${IKTYW}`);
    });

    if (idx !== -1 && idx !== listForRender.length - 1) {
      const clone = listForRender.slice();
      const [ik] = clone.splice(idx, 1);
      clone.push(ik);
      listForRender = clone;
      console.debug('[MGV] pin IKTYW -> bottom');
    }
  }

  console.debug('[MGV] out:', listForRender);

  return (
    <WhiteBox outerClass={classes.wrapper} innerClass={classes.innerWrapper}>
      {title && <h2 className={classes.title}>{title}</h2>}

      <ul className={classes.itemsList}>
        {listForRender.map((ele) => {
          const { _id, isGroup } = ele;
          const clickHandler = isGroup ? groupClickHandler : activityClickHandler;

          const feedbacks = (learners || []).map((learner) => {
            const report = learner.reports && learner.reports[_id];
            return report || {};
          });

          return (
            <li key={_id}>
              <button
                onClick={() => clickHandler && clickHandler(_id)}
                className={classnames(classes.item, {
                  [classes.clickable]: !!clickHandler,
                  [classes.itemGroup]: isGroup,
                  [classes.itemActivity]: !isGroup,
                  [classes.previous]: !isGroup && _id === highlight,
                })}
              >
                {withoutStars
                  ? null
                  : feedbacks.map((f, idx) => (
                      <div key={idx}>
                        <StarIcon
                          idx={idx}
                          mastered={f.mastered}
                          partial={f.partial}
                        />
                      </div>
                    ))}

                {ele.formattedName}
              </button>
            </li>
          );
        })}
      </ul>
    </WhiteBox>
  );
};

MenuGroupView.propTypes = {
  withoutStars: PropTypes.bool,
  title: PropTypes.string,
  items: PropTypes.array.isRequired,
  activityClickHandler: PropTypes.func,
  groupClickHandler: PropTypes.func,
  learners: PropTypes.array,
  highlight: PropTypes.string,
  solutionLocale: PropTypes.object,
};

export default MenuGroupView;